(function($) {
	/* Input Grid Plugin
	 * 
	 * The input grid maintains a number of rows/columns for a specified snippit of HTML. 
	 * It will duplicate the current row when 1 empty input remains. By default the input 
	 * is a single text box but can be overridden to handle complex inputs and custom HTML.
	 * To override the component, set the input configuration attribute as well as implement
	 * the getValue, setValue, setFocus, isEmpty and clearValue methods. Some methods may 
	 * not need to be overridden (with the default working properly).
	 */
	$.fn.originInputGrid = function(options) {
		return this.each(function() {
			var dataset = $(this).dataset();
			var opts = $.extend({
				columns: 5,
				rows: 2,
				input: '<input type="text" class="inputGridValue ignore-smooth-form" />',
				getValue: function() {
					return $(this).val() || '';
				},
				setValue: function(value) {
					$(this).val( value );
				},
				setFocus: function() {
					$(this).find(':text[value=]:eq(0)').focus();
				},
				isEmpty: function() {
					return $(this).val() == '';
				},
				clearValue: function() {
					$(this).val('');
				},
				validate: null,
				cssClass: null
			}, dataset || {}, options || {} );
			$(this)
				.data('options', opts)
				.addClass('originInputGrid')
				.bind('keyup', function(evt) {
					var options = $(this).data('options');
					var inputs = $(this).find('.inputGridValue').filter(function() {
						return options.isEmpty.call(this);
					});
					if ( inputs.length <= 1 ) {
						$(this)
							.closest('.originInputGrid')
							.originInputGridAdd( 1 );
					}
				});
			$(this).originInputGridAdd( opts.rows );
			if ( opts.values ) {
				var values = opts.values.split(/\s*,\s*/);
				$(this).originInputGridValues( values, false );
			}
		});
	};
	
	/*
	 * This method is used to add new empty rows to the grid.
	 */
	$.fn.originInputGridAdd = function(rows) {
		return this.each(function() {
			var options = $(this).closest('.originInputGrid').data('options');
			$('<div class="inputGridRow"></div>')
				.append(
					$( options.input )
						.If( options.cssClass != null )
							.addClass( options.cssClass )
						.end()
						.css('width', Math.floor( 87 / options.columns ) + '%')
						.duplicate( options.columns )
				)
				.duplicate( rows, true )
				.appendTo( this )
				.If( options.validate !== null )
					.find(':input') 
						.bind('blur', function() {
							var error = false;
							if ( typeof options.validate == 'string' ) {
								error = $(this).val().match( new RegExp( options.validate ) ) === null;
							} else if ( $.isFunction( options.validate ) ) {
								error = !!options.validate.call(this);
							}
							$(this).toggleClass('error', error);
						});
		});
	};
	
	/*
	 * This method clears the entire input grid (but does not change the number of input 
	 * rows.
	 */
	$.fn.originInputGridClear = function() {
		var options = $(this).closest('.originInputGrid').data('options');
		return this.find('.inputGridValue').each(function() {
			options.clearValue.call(this);
		}).end();
	};
	
	/*
	 * This method clears the entire input grid AND resets the number of rows to the 
	 * default specified by the options upon init.
	 */
	$.fn.originInputGridReset = function() {
		var options = $(this).closest('.originInputGrid').data('options');
		$(this).closest('.originInputGrid')
				.empty()
				.end()
				.originInputGridAdd( options.rows );
	};
	// Reduce the values to only a unique set
	// TODO:
	/*
	$.fn.originInputGridUnique = function() {
		return this.each(function() {
			
		});
	};
	*/
	
	/*
	 * Sets focus to the first empty element.
	 */
	$.fn.originInputGridFocus = function() {
		var options = $(this).closest('.originInputGrid').data('options');
		return this.each(function() {
			options.setFocus.call( this );
		});
	};
	
	/*
	 * Sets the grid to the values passed in the first argument (array). Optionally may 
	 * specify if the values should overwrite the current grid values or append to the grid 
	 * (expanding it as necessary). The final arguemnt is the unique flag.
	 *
	 * Returns an array of values when no arguments are passed in .originInputGridValues()
	 */
	$.fn.originInputGridValues = function(values, append, unique) {
		var options = $(this).closest('.originInputGrid').data('options');
		if ( arguments.length == 0 ) {
			var values = [];
			this.each(function() {
				$(this).find('.inputGridValue').each(function() {
					var value = options.getValue.call(this);
					if ( $.trim(value) != '' ) {
						values.push( value );
					}
				});
			});
			return values;
		}
		return this.each(function() {
			var inputs = $(this).find('.inputGridValue');
			
			if ( append !== false ) {
				inputs = inputs.filter(function() {
					return options.isEmpty.call(this);
				});
			} else {
				$(this).originInputGridClear();
			}
			
			if ( unique === true ) {
				var il = values.length;
				inputs.each(function() {
					for ( var i = 0; i < il; i++ ) {
						if ( values[i] == $(this).val() ) {
							values[i] = null;
							return false;
						}
					}
					return true;
				});

				var tmp = [];
				for ( var i = 0; i < il; i++ ) {
					if ( values[i] !== null ) {
						tmp.push( values[i] );
					}
				}
				values = tmp;
			}
			
			if ( ( inputs.length - 1 ) <= values.length ) {
				$(this).originInputGridAdd( Math.ceil( ( values.length - ( inputs.length - 1 ) ) / options.columns ) );
			}
			
			// We need to find the inputs again since we've modified the grid
			inputs = $(this).find('.inputGridValue');
			
			if ( append !== false ) {
				inputs = inputs.filter(function() {
					return options.isEmpty.call(this);
				});
			}
			
			// Only iterate over N inputs where N is the number of values we have to set
			inputs.slice(0, values.length).each(function() {
				options.setValue.call(this, values.shift());
			});
		});
	};
})(jQuery);